import {
  DropDown,
  ErrorMessage,
} from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import Tmnt from '../../../Tmnt/Tmnt';

const textProp = PropTypes.shape({
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

const baseDefaultProps = {
  value: undefined,
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  onChange: undefined,
  error: undefined,
  id: undefined,
};

const optionProp = PropTypes.shape({
  optionValue: PropTypes.string.isRequired,
  text: textProp.isRequired,
});

export const multiSelectPropTypes = {
  error: textProp,
  label: textProp.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string,
  optionList: PropTypes.arrayOf(optionProp),
};

const multiSelectDefaultProps = { ...baseDefaultProps, optionList: [] };

export default function AddressDropDown({
  value,
  error,
  isDisabled,
  isInvalid,
  isRequired,
  label,
  name,
  id,
  onChange,
  optionList,
}) {
  const inputId = id ?? `address-field-select-${name}`;

  const handleOnChange = (event) => {
    if (onChange) onChange(event);
  };

  const errorMessage = error && (
    <ErrorMessage id={`${id}-error-message`}>
      <Tmnt tmnt={error} />
    </ErrorMessage>
  );

  const processOptions = ({ optionValue, text }) => ({ label: text?.value, value: optionValue });

  return (
    <DropDown
      id={inputId}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label?.value}
      name={name}
      onChange={handleOnChange}
      options={optionList.map(processOptions)}
      value={value || ''}
    >
      {isInvalid && errorMessage}
    </DropDown>
  );
}

AddressDropDown.propTypes = multiSelectPropTypes;
AddressDropDown.defaultProps = multiSelectDefaultProps;
